import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { FormInputComponent } from '../../utils/form-input/form-input.component';
import {TranslateModule} from '@ngx-translate/core';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';

import { MdbButtonComponent } from '../../utils/mdb-button/mdb-button.component';
import { AuthService } from '../../../services/auth/auth.service';
import { finalize } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthWrapperComponent } from '../auth-wrapper/auth-wrapper.component';
import {HttpErrorsService} from "../../../services/utils/http-errors.service";

@Component({
    selector: 'app-login',
    imports: [
    ReactiveFormsModule,
    FormInputComponent,
    TranslateModule,
    MdbRippleModule,
    MdbButtonComponent,
    AuthWrapperComponent,
    RouterLink
],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent {
  loading: boolean = false;
  formGroup: FormGroup = this.formBuilder.group({
    username: [null, [Validators.required]],
    password: [null, [Validators.required]],
  });

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private httpErrorService: HttpErrorsService
  ) {}

  getFormControl(name: string): AbstractControl | null {
    return this.formGroup.get(name);
  }

  submit() {
    this.formGroup.markAllAsTouched();

    if (this.formGroup.invalid) return;

    this.loading = true;

    this.authService
      .login(
        this.getFormControl('username')?.value,
        this.getFormControl('password')?.value,
      )
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (token) => {
          this.router.navigate(['../']);
        },
        error: (e: HttpErrorResponse) => {
          this.httpErrorService.handleError(e)
        },
      });
  }

  protected readonly environment = environment;
}
